import Grid from "@mui/material/Grid/Grid";
import {
  CustomLabelMediumSmallBold,
  CustomLabelSmallMedium,
  CustomLabelSmallRegular,
  CustomLabelXSmallBold,
  CustomLabelXSmallMedium,
  CustomLabelXSmallRegular,
} from "../common/CustomLabel";
import XMARK from "../../assets/images/xmark.png";
import Stack from "@mui/material/Stack/Stack";
import LinearProgress from "@mui/material/LinearProgress/LinearProgress";
import Box from "@mui/material/Box/Box";
import { CustomTextField, CustomTextMultipleField } from "../common/text";
import InputAdornment from "@mui/material/InputAdornment/InputAdornment";
import USER from "../../assets/images/user.png";
import MAIL_BLACK from "../../assets/images/mail-black.png";
import ARROW_RIGHT_WITHOUT_BORDER from "../../assets/images/arrow-right-without-border.png";
import Paper from "@mui/material/Paper/Paper";
import ON_DEMAND_LAPTOP1 from "../../assets/images/on-demand-laptaop-1.png";
import ON_DEMAND_LAPTOP2 from "../../assets/images/on-demand-laptop-2.png";
import ON_DEMAND_LAPTOP3 from "../../assets/images/on-demand-laptop-3.png";
// import { CustomDropdown } from "../common/CustomDrowDown";
import CODE from "../../assets/images/code.png";
import CLOCK_RIGHT from "../../assets/images/clock-rotate-right.png";
import ARROR_LEFT from "../../assets/images/arrow-left.png";
import TICK from "../../assets/images/tick.png";
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import createTheme from "@mui/material/styles/createTheme";
import { transformValidateObject, validateUserInput } from "../../utils";
import { Chip } from '@mui/material';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowUp';
// import ARROW_DOWN from '@mui/icons-material/KeyboardArrowDown';

import { collection, addDoc } from "firebase/firestore";
import { db } from "src/firebase/firebaseConfig";
import Loader from "../common/Loader";
import Select from "@mui/material/Select";
import OSTRYX_LOGO from "../../assets/icons/OSTRYXNo.1Softwaredevelopmentcompany.webp";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 710,
      md: 950,
      lg: 1300,
      xl: 1350,
    },
  },
});

  const initialStep1Data = {
    full_name: { value: "", showError: false, error: "Field cant be empty" },
    email: { value: "", showError: false, error: "Field cant be empty" },
    project_title: { value: "", showError: false, error: "Field cant be empty" },
    project_description: {
      value: "",
      showError: false,
      error: "Field cant be empty",
    },
  };
  
  const initialStep2Data = {
      tech_stack: [],  // Array to store {title: "category", value: "tag"} objects
      showError: false,
      error: "Field cant be empty",
  };
  const initialStep3Data = {
      developer_level: {
        value: "Senior",
        showError: false,
        error: "Field cant be empty",
      }
    };
    const initialStep4Data = {
        developer_type: {
        value: "full-time",
        showError: false,
        error: "Field cant be empty",
        },
        project_duration: {
        value: "",
        showError: false,
        error: "Field cant be empty",
        },
        total_cost: {
        value: "",
        showError: false,
        error: "Field cant be empty",
        },
    };
  
  const initialStep5Data = {
    job_description: {
      value: "",
      showError: false,
      error: "Field cant be empty",
    },
    addiotional_info: {
      value: "",
      showError: false,
      error: "Field cant be empty",
    },
  };
  const OnDemandDevelopers = ({
    setShowOnDemandDevelopers,
    setShowConfirmation,
  }) => {
    // const [isMenuClicked, setIsMenuClicked] = useState(false);
  
    const [progress, setProgress] = useState(5);

  const [step1, setStep1] = useState(initialStep1Data);
  const [step2, setStep2] = useState(initialStep2Data);
  const [step3, setStep3] = useState(initialStep3Data);
  const [step4, setStep4] = useState(initialStep4Data);
  const [step5, setStep5] = useState(initialStep5Data);

  const [isLoading, setIsLoading] = useState(false);

  const [count, setCount] = useState(0);

  // const [showWebFrontend, setShowWebFrontend] = useState(false);
  // const [showBackend, setShowBackend] = useState(false);
  // const [showMobile, setShowMobile] = useState(false);
  const [selectedTags, setSelectedTags] = useState({});

  const [openCategories, setOpenCategories] = useState({
    'Web & Frontend Development': true
  });

  const [hourlyValue, setHourlyValue] = useState(0);

  // Add new state for tech stack selection error
  const [techStackError, setTechStackError] = useState(false);

  // Add new state for hourly validation
  const [hourlyError, setHourlyError] = useState(false);

  const [step4Errors, setStep4Errors] = useState({});
  const [step5Errors, setStep5Errors] = useState({});

  useEffect(() => {}, []);

  const techStackIcons = {
    //   'React.js Developer': REACT_ICON,
    //   'Next.js Developer': NEXT_ICON,
      // ... add more icons
    };
    
    const techStackPricing = {
      'Web & Frontend Developers': {
        Intermediate: 15,
        Mid_level: 25,
        Senior: 35
      },
      'Backend Developers': {
        Intermediate: 20,
        Mid_level: 30,
        Senior: 40
      },
      'Mobile App Developers': {
        Intermediate: 20,
        Mid_level: 30,
        Senior: 40
      },
      'Full-Stack Developers': {
        Intermediate: 25,
        Mid_level: 35,
        Senior: 45
      },
      'Software & Windows App Developers': {
        Intermediate: 30,
        Mid_level: 40,
        Senior: 50
      },
      'Database & Cloud Experts': {
        Intermediate: 25,
        Mid_level: 35,
        Senior: 45
      },
      'API & Integration Experts': {
        Intermediate: 20,
        Mid_level: 25,
        Senior: 30
      },
      'Ecommerce Experts': {
        Intermediate: 15,
        Mid_level: 20,
        Senior: 25
      },
      'DevOps & Cybersecurity': {
        Intermediate: 25,
        Mid_level: 40,
        Senior: 55
      }
    };
    
    const TechStackCategory = ({ title, tags, isOpen, onToggle, onTagSelect, selectedTags, value }) => (
      <Grid item>
        <Grid 
          container 
          direction="column"
          sx={{
            border: '1px solid #DDDDDD',
            borderRadius: 5,
            background: 'white',
            overflow: 'hidden'
          }}
        >
          <Grid 
            container 
            alignItems="center" 
            justifyContent="space-between"
            onClick={onToggle}
            sx={{
              cursor: 'pointer',
              padding: '15px',
            }}
          >
            <Grid item>
              <CustomLabelSmallRegular text={title} />
            </Grid>
            <KeyboardArrowDown 
              sx={{ 
                transition: 'transform 0.3s ease',
                transform: isOpen ? 'rotate(0)' : 'rotate(180deg)',
              }} 
            />
          </Grid>
    
          {isOpen && (
            <Grid container spacing={1} sx={{ p: 2 }}>
              {tags.map((tag, index) => (
                <Grid item key={index}>
                  <Chip
                    icon={<img src={techStackIcons[tag] || CODE} alt={tag} style={{width: 16, height: 16}} />}
                    label={tag}
                    sx={{
                      background: selectedTags.includes(tag) ? '#5E17EB' : '#F5F5F5',
                      borderRadius: '20px',
                      padding: '5px 10px',
                      color: selectedTags.includes(tag) ? 'white' : 'black',
                      '& .MuiChip-icon': {
                        color: selectedTags.includes(tag) ? 'white' : '#666666'
                      },
                      '&:hover': {
                        background: '#5E17EB',
                        color: 'white',
                        '& .MuiChip-icon': {
                          color: 'white'
                        }
                      }
                    }}
                    onClick={() => onTagSelect(tag, title)}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </Grid>
      </Grid>
    );
    
    const techStackCategories = {
      'Web & Frontend Developers': [
        'React.js Developer',
        'Next.js Developer', 
        'Vue.js Developer',
        'Angular Developer',
        'HTML/CSS/JavaScript Developer'
      ],
      'Backend Developers': [
        'Node.js Developer',
        'Nest.js Developer',
        'Express.js Developer',
        'Laravel/PHP Developer',
        'Python/Django Developer',
        'Golang Developer',
        'Ruby on Rails Developer'
      ],
      'Mobile App Developers': [
        'React Native Developer',
        'Flutter Developer',
        'Kotlin Android Developer',
        'iOS Developer (Swift)',
        'Native App Developer'
      ],
      'Full-Stack Developers': [
        'MERN Stack Developer',
        'MEAN Stack Developer',
        'JAMstack Developer'
      ],
      'Software & Windows App Developers': [
        'Electron.js Developer',
        'C#/.NET Developer', 
        'Java Developer'
      ],
      'Database & Cloud Experts': [
        'PostgreSQL Developer',
        'MySQL Developer', 
        'MongoDB Developer',
        'Firebase Developer',
        'AWS Developer',
        'Google Cloud Developer',
        'Azure Developer'
      ],
      'API & Integration Experts': [
        'REST API Developer',
        'GraphQL Developer',
        'Payment Gateway Integration Expert'
      ],
      'Ecommerce Experts': [
        'SEO Specialist',
        'WordPress Developer',
        'Shopify Developer', 
        'WooCommerce Developer'
      ],
      'DevOps & Cybersecurity': [
        'DevOps Engineer (AWS, Azure, GCP)',
        'Cybersecurity Specialist',
        'Blockchain Developer',
        'Smart Contract Developer'
      ]
    };
    
    const StarIcon = () => {
        return (    
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_43404_888)">
            <path d="M8.29369 8.01893L9.59245 5.26514C9.75917 4.91162 10.2408 4.91162 10.4076 5.26514L11.7063 8.01893L14.6107 8.46325C14.9834 8.52025 15.1319 8.99967 14.8621 9.27469L12.7609 11.4167L13.2568 14.4428C13.3205 14.8315 12.9307 15.1278 12.5973 14.9443L10 13.5147L7.40273 14.9443C7.0693 15.1278 6.67954 14.8315 6.74323 14.4428L7.23913 11.4167L5.13788 9.27469C4.86809 8.99967 5.01661 8.52025 5.38926 8.46325L8.29369 8.01893Z" fill="#5E17EB" stroke="#5E17EB" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18.333 10L19.1663 10" stroke="#5E17EB" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 1.66667V0.833338" stroke="#5E17EB" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 19.1667V18.3333" stroke="#5E17EB" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16.667 16.6667L15.8337 15.8333" stroke="#5E17EB" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16.667 3.33333L15.8337 4.16666" stroke="#5E17EB" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.33301 16.6667L4.16634 15.8333" stroke="#5E17EB" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.33301 3.33333L4.16634 4.16666" stroke="#5E17EB" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M0.833008 10L1.66634 10" stroke="#5E17EB" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
            <clipPath id="clip0_43404_888">
                <rect width="20" height="20" fill="white"/>
                </clipPath>
                </defs>
            </svg>
        )
    }

  const saveProject = async (database, data) => {
    try {
      await addDoc(collection(db, database), {
        ...data,
        createdAt: new Date(),
      });
    } catch (error) {
      console.error("Error saving project:", error);
    }
  };

  const onChangeStep1 = (e, type) => {
    let data;
    let value = e.target.value;

    data = { ...step1, [type]: { ...step1[type], value: value } };
    setStep1(data);
  };

  const onChangeStep2 = (e, type) => {
    let data;
    let value = e.target.value;

    data = { ...step2, [type]: { ...step2[type], value: value } };
    setStep2(data);
  };

  const onChangeStep3 = (e, type) => {
    let data;
    let value = e.target.value;

    data = { ...step3, [type]: { ...step3[type], value: value } };
    setStep3(data);
  };

  const onChangeStep4 = (e, type) => {
    let data;
    let value = e.target.value;

    // Calculate the new total cost whenever project_duration or developer_type changes
    const { totalCost, savings, isHourly } = calculateTotalCost(
      selectedTags,
      step3.developer_level.value,
      type === 'project_duration' ? value : step4.project_duration.value,
      type === 'developer_type' ? value : step4.developer_type.value,
      hourlyValue
    );

    // Create updated step4 data
    data = {
      ...step4,
      [type]: { ...step4[type], value: value },
      total_cost: {
        ...step4.total_cost,
        value: isHourly ? totalCost.toString() : (totalCost - savings).toString()
      }
    };

    setStep4(data);
  };

  const onChangeStep5 = (e, type) => {
    let data;
    let value = e.target.value;

    data = { ...step5, [type]: { ...step5[type], value: value } };
    setStep5(data);
  };

  const onSubmitStep1 = (e) => {
    const validate = validateUserInput(step1);
    if (validate.isValid) {
      setProgress(25);
    } else {
      setStep1(validate.data);
      setCount(count + 1);
    }
    console.log('step1', step1);
  };

  const onSubmitStep2 = (e) => {
    // Check if any tech stack is selected
    if (Object.keys(selectedTags).length === 0) {
      // Set error state to true to display error message
      setTechStackError(true);
      return;
    }
    else {
     setProgress(45);
      setTechStackError(false);
    }
    console.log('step2', step2);
  };

  const onSubmitStep3 = async (e) => {
    setProgress(65);
    console.log('step3', step3);
  }

  const validateStep4 = () => {
    const errors = {};
    
    if (step4.developer_type.value === "hourly") {
      // Validate hourly input
      if (!hourlyValue || hourlyValue < 5) {
        errors.hourlyValue = "Please enter at least 5 hours";
        setHourlyError(true);
      }
    } else {
      // Validate project duration for non-hourly types
      if (!step4.project_duration.value) {
        errors.project_duration = "Please select project duration";
      }
    }
    
    return errors;
  };

  const validateStep5 = () => {
    const errors = {};
    // Add validation logic for step 5
    // For example:
    // if (!step5Data.someField) {
    //   errors.someField = "This field is required";
    // }
    return errors;
  };

  const onSubmitStep4 = async (e) => {
    e.preventDefault();
    const errors = validateStep4();
    
    if (Object.keys(errors).length === 0) {
      // Create new step4 data without hourly_value
      const updatedStep4 = {
        developer_type: step4.developer_type,
        project_duration: {
          ...step4.project_duration,
          value: step4.developer_type.value === "hourly" 
            ? `${hourlyValue} Hours` 
            : step4.project_duration.value
        },
        total_cost: step4.total_cost
      };
      
      // Update state with new structure
      setStep4(updatedStep4);
      
      // proceed to next step
      setProgress(90);
    } else {
      // handle validation errors
      setStep4Errors(errors);
    }
    console.log('step4', step4);
  };

  const onSubmitStep5 = async (e) => {
    e.preventDefault();
    const errors = validateStep5();
    if (Object.keys(errors).length === 0) {
      // Save the project with all data from steps 1-5
      const projectData = {
        ...transformValidateObject(step1),
        tech_stack: step2.tech_stack,
        ...transformValidateObject(step3),
        ...transformValidateObject(step4),
        ...transformValidateObject(step5),
      };
    console.log('step5', step5);
      console.log('data', projectData);
      setIsLoading(true);
      await saveProject("on-demand-developers", projectData);
      setShowOnDemandDevelopers(false);
      setShowConfirmation(true);
      setIsLoading(false);
    } else {
      // handle validation errors
      setStep5Errors(errors);
    }
  };

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const DeveloperStackListContainer = [
    "MERN (MongoDB, Express.js, React, Node.js)",
    "MEAN (MongoDB, Express.js, Angular, Node.js)",
    "LAMP (Linux, Apache, MySQL, PHP)",
    "LEMP (Linux, Nginx, MySQL, PHP)",
    "JAMstack (JavaScript, APIs, Markup)",
    "Django + PostgreSQL + Nginx",
    "Ruby on Rails + PostgreSQL",
    "Spring Boot + React + MySQL",
  ].map((list) => (
    <MenuItem value={list}>
      <CustomLabelSmallRegular text={list} />
    </MenuItem>
  ));

  const DurationListContainer = [
    "1 Week",
    "2 Weeks",
    "1 Month",
    "3 Months",
    "6 Months",
    "1 Year Or More",
  ].map((list) => (
    <MenuItem value={list}>
      <CustomLabelSmallRegular text={list} />
    </MenuItem>
  ));

  const handleTagClick = (tag, category) => {
    // Create updated tags first
    const newSelectedTags = { ...selectedTags };
    
    // If clicking already selected tag, remove it
    if (newSelectedTags[category] === tag) {
      delete newSelectedTags[category];
    } else {
      // Otherwise set new tag for this category
      newSelectedTags[category] = tag;
    }
    
    // Update selectedTags state
    setSelectedTags(newSelectedTags);
    
    // Update step2.tech_stack directly with the new data
    const techStackArray = Object.entries(newSelectedTags).map(([cat, tg]) => ({
      title: cat,
      value: tg
    }));
    
    setStep2(prev => ({
      ...prev,
      tech_stack: techStackArray
    }));
  };

  const handleCategoryToggle = (category) => {
    setOpenCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  const calculateTotalCost = (selectedTags, developerLevel, projectDuration, developerType, hourlyValue) => {
    let totalHourlyRate = 0;
    
    // Calculate total hourly rate from all selected tech stacks
    Object.entries(selectedTags).forEach(([category, tag]) => {
      const categoryPricing = techStackPricing[category];
      if (categoryPricing) {
        totalHourlyRate += categoryPricing[developerLevel];
      }
    });

    // Calculate hours based on developer type
    let hoursPerMonth = 0;
    let totalHours = 0;
    
    if (developerType === 'hourly') {
      // For hourly, use the direct input value
      totalHours = parseInt(hourlyValue) || 0;
      hoursPerMonth = totalHours;
    } else {
      // For part-time/full-time calculate based on type and duration
      switch (developerType) {
        case 'full-time':
          hoursPerMonth = 160; // 40 hours * 4 weeks
          break;
        case 'part-time':
          hoursPerMonth = 80; // 20 hours * 4 weeks
          break;
        default:
          hoursPerMonth = 160;
      }
      
      // Extract number of months from duration string
      const months = parseInt(projectDuration) || 1;
      totalHours = hoursPerMonth * months;
    }
    
    // Calculate total cost (ensure we're using full integer values)
    const totalCost = Math.round(totalHourlyRate * totalHours);
    const savings = Math.round(totalCost * 0.1); // 10% savings
    
    return {
      hourlyRate: totalHourlyRate,
      totalCost: totalCost,
      totalHours: totalHours,
      savings: savings,
      isHourly: developerType === 'hourly'
    };
  };
  const handleClickOutside = (e) => {
    if (e.target === e.currentTarget) {
      setShowOnDemandDevelopers(false);
    }
  };
  return (
    <>
    <Grid 
        container 
        className="modal-overlay"
        onClick={handleClickOutside}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Grid item onClick={e => e.stopPropagation()}>
      {isLoading && <Loader />}
      <Grid
        direction={"row"}
        container
        item
        xs={12}
        sm={10}
        md={8}
        lg={5.5}
        justifyContent={"center"}
        sx={{
          position: "fixed",
          top: 0,
          right: 0,
          zIndex: 11,
          padding: { xs: "20px 10px", sm: "40px", md: "40px" },
          background: "#FAF7FF",
          borderRadius: "25px 0px 0px 25px",
          overflowY: "scroll",
          height: "100%",
        }}
      >
        <form>
          <Grid
            item
            container
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Grid item xs={9}>
              <CustomLabelMediumSmallBold
                text={"On-Demand Developers"}
                color={"#5E17EB"}
              />
            </Grid>
            <Grid item>
              <Grid item container justifyContent={"center"}>
                <Grid
                  item
                  container
                  style={{
                    border: "1.5px solid #DDDDDD",
                    background: "white",
                    borderRadius: "20px",
                    width: "56px",
                    height: "56px",
                    cursor: "pointer",
                  }}
                  alignItems={"center"}
                  justifyContent={"center"}
                  onClick={(e) => setShowOnDemandDevelopers(false)}
                >
                  <Grid item>
                    <img src={XMARK} alt={"XMARK"} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item container sx={{ marginTop: { xs: "10px" } }}>
            <CustomLabelSmallRegular
              text={"Find the right developer for your project."}
            />
          </Grid>

          <Grid
            item
            container
            xs={12}
            sx={{ marginTop: { xs: "20px", md: "40px" } }}
          >
            <Stack spacing={2} sx={{ flex: 1, position: "relative" }}>
              <LinearProgress
                variant="determinate"
                value={progress}
                sx={{
                  height: 10,
                  borderRadius: 5,
                  border: "1px solid #DDDDDD",
                  backgroundColor: "white", // Background color
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: "#5E17EB", // Progress bar color
                  },
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  top: -10,
                  left: `calc(${progress}% - 10px)`,
                  transform: "translateY(-50%)",
                  width: 15,
                  height: 15,
                  borderRadius: "50%",
                  backgroundColor: "#5E17EB",
                  border: "1px solid white",
                  boxShadow: "0 0 5px rgba(0,0,0,0.5)",
                  transition: "left 0.5s ease",
                }}
              />
            </Stack>
            <Grid
              container
              justifyContent={"space-between"}
              sx={{ marginTop: { xs: "5px", md: "5px" } }}
            >
              <Grid item>
                <CustomLabelXSmallMedium
                  text={"Basic Info"}
                  color={"#5E17EB"}
                />
              </Grid>
              <Grid item>
                <CustomLabelXSmallMedium
                  text={"Tech Stack"}
                  color={"#5E17EB"}
                />
              </Grid>
              <Grid item>
                <CustomLabelXSmallMedium text={"Dev Level"} color={"#5E17EB"} />
              </Grid>
              <Grid item>
                <CustomLabelXSmallMedium
                  text={"Project Duration"}
                  color={"#5E17EB"}
                />
              </Grid>
              <Grid item>
                <CustomLabelXSmallMedium
                  color={"#5E17EB"}
                  text={"Additional Details"}
                />
              </Grid>
            </Grid>

            {progress === 5 && (
              <Grid container sx={{ marginTop: { xs: "15px", md: "30px" } }}>
                <Grid item xs={12} container justifyContent={"flex-start"}>
                  <Grid item style={{ marginLeft: 10 }}>
                    <CustomLabelXSmallRegular text={"Full Name"} />
                  </Grid>
                  <Grid item container style={{ marginTop: 5 }}>
                    <CustomTextField
                      placeholder={"Type your full name here..."}
                      height={isMobile && "50px"}
                      value={step1.full_name.value}
                      onChange={(e) => onChangeStep1(e, "full_name")}
                      error={step1.full_name.showError}
                      helperText={
                        step1.full_name.showError ? step1.full_name.error : ""
                      }
                      startAdornment={
                        <InputAdornment position="start">
                          <img src={USER} alt={"USER"} />
                        </InputAdornment>
                      }
                      otherInputProps={{
                        sx: {
                            '&.MuiOutlinedInput-root': {
                                backgroundColor: "white",
                              },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#5E17EB',
                            borderWidth: '1px',
                          },
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  container
                  justifyContent={"flex-start"}
                  style={{ marginTop: "20px" }}
                >
                  <Grid item style={{ marginLeft: 10 }}>
                    <CustomLabelXSmallRegular text={"Email Address"} />
                  </Grid>
                  <Grid item container style={{ marginTop: 5}}>
                    <CustomTextField
                      placeholder={"example@email.com"}
                      height={isMobile && "50px"}
                      value={step1.email.value}
                      onChange={(e) => onChangeStep1(e, "email")}
                      error={step1.email.showError}
                      helperText={
                        step1.email.showError ? step1.email.error : ""
                      }
                      startAdornment={
                        <InputAdornment position="start">
                          <img src={MAIL_BLACK} alt={"MAIL_BLACK"} />
                        </InputAdornment>
                      }
                      otherInputProps={{
                        sx: {
                            '&.MuiOutlinedInput-root': {
                                backgroundColor: "white",
                              },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#5E17EB',
                            borderWidth: '1px',
                          },
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  container
                  justifyContent={"flex-start"}
                  style={{ marginTop: "20px" }}
                >
                  <Grid item style={{ marginLeft: 10 }}>
                    <CustomLabelXSmallRegular text={"Project Title"} />
                  </Grid>
                  <Grid item container style={{ marginTop: 5}}>
                    <CustomTextField
                      placeholder={"Type here..."}
                      height={isMobile && "50px"}
                      value={step1.project_title.value}
                      onChange={(e) => onChangeStep1(e, "project_title")}
                      error={step1.project_title.showError}
                      helperText={
                        step1.project_title.showError
                          ? step1.project_title.error
                          : ""
                      }
                      otherInputProps={{
                        sx: {
                            '&.MuiOutlinedInput-root': {
                                backgroundColor: "white",
                              },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#5E17EB',
                            borderWidth: '1px',
                          },
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container style={{ marginTop: "20px" }}>
                  <Grid item style={{ marginLeft: 10 }}>
                    <CustomLabelXSmallRegular text={"Project Description"} />
                  </Grid>
                  <Grid item container style={{ marginTop: 5}}>
                    <CustomTextMultipleField
                      placeholder={"What's on your mind?"}
                      rows={5}
                      value={step1.project_description.value}
                      onChange={(e) => onChangeStep1(e, "project_description")}
                      error={step1.project_description.showError}
                      helperText={
                        step1.project_description.showError
                          ? step1.project_description.error
                          : ""
                      }
                      otherInputProps={{
                        sx: {
                            '&.MuiOutlinedInput-root': {
                                backgroundColor: "white",
                              },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#5E17EB',
                            borderWidth: '1px',
                          },
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid
                  item
                  container
                  justifyContent={"center"}
                  style={{ marginTop: "10px" }}
                >
                  <div>
                    <Grid
                      container
                      alignItems={"center"}
                      justifyContent={"center"}
                      sx={{
                        border: "1.5px solid #F5F5F5",
                        borderRadius: "20px",
                        padding: { xs: "10px 40px", md: "12px 60px" },
                        background: "#5E17EB",
                        marginTop: "20px",
                        cursor: "pointer",
                      }}
                      onClick={onSubmitStep1}
                    >
                      <Grid item>
                        <CustomLabelSmallMedium text={"Next"} color={"white"} />
                      </Grid>

                      <Grid
                        item
                        style={{ marginLeft: "5px", marginTop: "4px" }}
                      >
                        <img src={ARROW_RIGHT_WITHOUT_BORDER} alt={"ARROW_RIGHT_WITHOUT_BORDER"} />
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            )}
            {progress === 25 && (
              <Grid container sx={{ marginTop: { xs: "30px", md: "40px" } }}>
                <Grid item xs={12} container justifyContent={"flex-start"}>
                  <Grid item style={{ marginLeft: 10 }}>
                    <CustomLabelXSmallRegular text={"Tech Stack & Developer"} />
                  </Grid>
                  
                  {/* Add error message */}
                  {techStackError && (
                    <Grid item xs={12}>
                      <CustomLabelXSmallRegular 
                        text={"Please select at least one tech stack"} 
                        color={"#d32f2f"} // Use the same color as other form errors
                        sx={{ marginLeft: 1, marginTop: 0.5 }}
                      />
                    </Grid>
                  )}
                  
                  <Grid container direction="column" spacing={1} sx={{ mt: 1 }}>
                    {Object.entries(techStackCategories).map(([category, tags]) => (
                      <TechStackCategory
                        key={category}
                        title={category}
                        tags={tags}
                        isOpen={openCategories[category]}
                        onToggle={() => handleCategoryToggle(category)}
                        onTagSelect={handleTagClick}
                        selectedTags={Object.values(selectedTags)}
                        value={step2.tech_stack.map(item => item.value || "")}
                      />
                    ))}
                  </Grid>

                  <Grid
                    item
                    container
                    justifyContent={"center"}
                    sx={{ paddingBottom: "40px", marginTop: "20px" }}
                  >
                    <div>
                      <Grid
                        container
                        alignItems={"center"}
                        justifyContent={"center"}
                        sx={{
                          border: "1.5px solid #DDDDDD",
                          borderRadius: "20px",
                          padding: { xs: "10px 40px", md: "12px 80px" },
                          background: "white",
                          marginTop: "20px",
                          gap: "5px",
                          cursor: "pointer",
                        }}
                        onClick={(e) => setProgress(5)}
                      >
                        <Grid item style={{ marginTop: "2px" }}>
                          <img src={ARROR_LEFT} alt={"ARROR_LEFT"} />
                        </Grid>

                        <Grid item>
                          <CustomLabelSmallMedium
                            text={"Back"}
                            color={"black"}
                          />
                        </Grid>
                      </Grid>
                    </div>

                    <div style={{ marginLeft: "20px" }}>
                      <Grid
                        container
                        alignItems={"center"}
                        justifyContent={"center"}
                        sx={{
                          border: "1.5px solid #F5F5F5",
                          borderRadius: "20px",
                          padding: { xs: "10px 40px", md: "12px 80px" },
                          background: "#5E17EB",
                          marginTop: "20px",
                          gap: "5px",
                          cursor: "pointer",
                        }}
                        onClick={onSubmitStep2}
                      >
                        <Grid item>
                          <CustomLabelSmallMedium
                            text={"Next"}
                            color={"white"}
                          />
                        </Grid>

                        <Grid item style={{ marginTop: "4px" }}>
                          <img src={ARROW_RIGHT_WITHOUT_BORDER} alt={"ARROW_RIGHT_WITHOUT_BORDER"} />
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>

                </Grid>
              </Grid>
            )}
            {progress === 45 && (
              <Grid container>
                <Grid container sx={{ marginTop: { xs: "30px", md: "40px" } }}>
                  <Grid item xs={12} container justifyContent={"flex-start"}>
                    <Grid item style={{ marginLeft: 10 }}>
                      <CustomLabelXSmallRegular
                        text={"What level of developer do you need?"}
                      />
                    </Grid>
                    <Grid item container style={{ marginTop: 5 }}>
                      <Grid container justifyContent={"space-between"}>
                        <Grid item xs={5.5} md={3.5}>
                          <Paper
                            onClick={(e) =>
                              onChangeStep3(
                                { target: { value: "Intermediate" } },
                                "developer_level"
                              )
                            }
                            sx={{
                              width: "100%",
                              background: "white",
                              padding: "20px 10px",
                              borderRadius: "25px",
                              cursor: "pointer",
                              border:
                                step3.developer_level.value === "Intermediate" &&
                                "1px solid #5E17EB",
                            }}
                          >
                            <Grid
                              container
                              alignItems={"center"}
                              direction={"column"}
                            >
                              <Grid item>
                                <img src={ON_DEMAND_LAPTOP1} alt={"ON_DEMAND_LAPTOP1"} />
                              </Grid>
                              <Grid item style={{ marginTop: "5px" }}>
                                <CustomLabelXSmallBold
                                  color={
                                    step3.developer_level.value === "Intermediate"
                                      ? "#5E17EB"
                                      : "#A3A3A3"
                                  }
                                  text={"Intermediate "}
                                />
                              </Grid>
                              <Grid item>
                                <CustomLabelXSmallRegular
                                  color={"#A3A3A3"}
                                  text={"2-3 years experience"}
                                />
                              </Grid>
                              <Grid></Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                        <Grid item xs={5.5} md={3.5}>
                          <Paper
                            onClick={(e) =>
                              onChangeStep3(
                                { target: { value: "Mid_level" } },
                                "developer_level"
                              )
                            }
                            sx={{
                              width: "100%",
                              background: "white",
                              padding: "20px 10px",
                              borderRadius: "25px",
                              cursor: "pointer",
                              border:
                                step3.developer_level.value ===
                                  "Mid_level" && "1px solid #5E17EB",
                            }}
                          >
                            <Grid
                              container
                              alignItems={"center"}
                              direction={"column"}
                            >
                              <Grid item>
                                <img src={ON_DEMAND_LAPTOP2} alt={"ON_DEMAND_LAPTOP2"} />
                              </Grid>
                              <Grid item style={{ marginTop: "5px" }}>
                                <CustomLabelXSmallBold
                                  color={
                                    step3.developer_level.value ===
                                    "Mid_level"
                                      ? "#5E17EB"
                                      : "#A3A3A3"
                                  }
                                  text={"Mid Level"}
                                />
                              </Grid>
                              <Grid item>
                                <CustomLabelXSmallRegular
                                  color={"#A3A3A3"}
                                  text={
                                    "3-5 years experience"
                                  }
                                />
                              </Grid>
                              <Grid></Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                        <Grid
                          item
                          xs={5.5}
                          md={3.5}
                          sx={{ marginTop: { xs: "5px", md: "0px" } }}
                        >
                          <Paper
                            onClick={(e) =>
                              onChangeStep3(
                                { target: { value: "Senior" } },
                                "developer_level"
                              )
                            }
                            sx={{
                              width: "100%",
                              background: "white",
                              padding: "20px 10px",
                              borderRadius: "25px",
                              cursor: "pointer",
                              border:
                                step3.developer_level.value === "Senior" &&
                                "1px solid #5E17EB",
                            }}
                          >
                            <Grid
                              container
                              alignItems={"center"}
                              direction={"column"}
                            >
                              <Grid item>
                                <img src={ON_DEMAND_LAPTOP3} alt={"ON_DEMAND_LAPTOP3"} />
                              </Grid>
                              <Grid item style={{ marginTop: "5px" }}>
                                <CustomLabelXSmallBold
                                  color={
                                    step3.developer_level.value === "Senior"
                                      ? "#5E17EB"
                                      : "#A3A3A3"
                                  }
                                  text={"Senior"}
                                />
                              </Grid>
                              <Grid item>
                                <CustomLabelXSmallRegular
                                  color={"#A3A3A3"}
                                  text={"5+ years experience"}
                                />
                              </Grid>
                              <Grid></Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    container
                    justifyContent={"center"}
                    sx={{ paddingBottom: "40px", marginTop: "20px" }}
                  >
                    <div>
                      <Grid
                        container
                        alignItems={"center"}
                        justifyContent={"center"}
                        sx={{
                          border: "1.5px solid #DDDDDD",
                          borderRadius: "20px",
                          padding: { xs: "10px 40px", md: "12px 80px" },
                          background: "white",
                          marginTop: "20px",
                          gap: "5px",
                          cursor: "pointer",
                        }}
                        onClick={(e) => setProgress(25)}
                      >
                        <Grid item style={{ marginTop: "2px" }}>
                          <img src={ARROR_LEFT} alt={"ARROR_LEFT"} />
                        </Grid>

                        <Grid item>
                          <CustomLabelSmallMedium
                            text={"Back"}
                            color={"black"}
                          />
                        </Grid>
                      </Grid>
                    </div>

                    <div style={{ marginLeft: "20px" }}>
                      <Grid
                        container
                        alignItems={"center"}
                        justifyContent={"center"}
                        sx={{
                          border: "1.5px solid #F5F5F5",
                          borderRadius: "20px",
                          padding: { xs: "10px 40px", md: "12px 80px" },
                          background: "#5E17EB",
                          marginTop: "20px",
                          gap: "5px",
                          cursor: "pointer",
                        }}
                        onClick={onSubmitStep3}
                      >
                        <Grid item>
                          <CustomLabelSmallMedium
                            text={"Next"}
                            color={"white"}
                          />
                        </Grid>

                        <Grid item style={{ marginTop: "4px" }}>
                          <img src={ARROW_RIGHT_WITHOUT_BORDER} alt={"ARROW_RIGHT_WITHOUT_BORDER"} />
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            )}
            {progress === 65 && (
              <Grid container sx={{ marginTop: { xs: "30px", md: "40px" } }}>
                <Grid item xs={12} container justifyContent={"flex-start"}>
                  <Grid item style={{ marginLeft: 10 }}>
                    <CustomLabelXSmallRegular text={"Do you need a developer for:"} />
                  </Grid>
                  <Grid item container style={{ marginTop: 5 }}>
                    <Grid container justifyContent={"space-between"}>
                      <Grid item xs={3.5}>
                        <Paper
                          onClick={(e) => {
                            // Reset hourly value when switching to hourly type
                            setHourlyValue("");
                            // Reset project duration
                            onChangeStep4({target: {value: ""}}, "project_duration");
                            // Change developer type to hourly
                            onChangeStep4({target: {value: "hourly"}}, "developer_type");
                          }}
                          sx={{
                            width: "100%",
                            background: "white", 
                            padding: "20px 10px",
                            borderRadius: "25px",
                            cursor: "pointer",
                            border: step4.developer_type.value === "part-time" && "1px solid #5E17EB"
                          }}
                        >
                          <Grid container alignItems={"center"} direction={"column"}>
                            <Grid item>
                              <CustomLabelXSmallBold
                                color={step4.developer_type.value === "part-time" ? "#5E17EB" : "#A3A3A3"}
                                text={"Part-time"}
                              />
                            </Grid>
                            <Grid item>
                              <CustomLabelXSmallRegular 
                                color={"#A3A3A3"}
                                text={"20 hours / week"}
                              />
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>

                      <Grid item xs={3.5}>
                        <Paper
                          onClick={(e) => onChangeStep4({target: {value: "full-time"}}, 'developer_type')}
                          sx={{
                            width: "100%",
                            background: "white",
                            padding: "20px 10px", 
                            borderRadius: "25px",
                            cursor: "pointer",
                            border: step4.developer_type.value === "full-time" && "1px solid #5E17EB"
                          }}
                        >
                          <Grid container alignItems={"center"} direction={"column"}>
                            <Grid item>
                              <CustomLabelXSmallBold
                                color={step4.developer_type.value === "full-time" ? "#5E17EB" : "#A3A3A3"}
                                text={"Full-time"}
                              />
                            </Grid>
                            <Grid item>
                              <CustomLabelXSmallRegular
                                color={"#A3A3A3"}
                                text={"40 hours / week"}
                              />
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>

                      <Grid item xs={3.5}>
                        <Paper
                          onClick={(e) => {
                            setHourlyValue("");
                            onChangeStep4({target: {value: "hourly"}}, 'developer_type')}
                          }
                          sx={{
                            width: "100%",
                            background: "white",
                            padding: "30px 10px",
                            borderRadius: "25px", 
                            cursor: "pointer",
                            border: step4.developer_type.value === "hourly" && "1px solid #5E17EB"
                          }}
                        >
                          <Grid container alignItems={"center"} direction={"column"}>
                            <Grid item>
                              <CustomLabelXSmallBold
                                color={step4.developer_type.value === "hourly" ? "#5E17EB" : "#A3A3A3"}
                                text={"Hourly"}
                                
                              />
                            </Grid>

                          </Grid>
                        </Paper>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} container justifyContent={"flex-start"} style={{ marginTop: "20px" }}>
                    <Grid item style={{ marginLeft: 10 }}>
                        <CustomLabelXSmallRegular text={step4.developer_type.value === "hourly" ? "How many hours do you need?" : "What's the estimated duration of the project?"} />
                    </Grid>
                    <Grid item xs={12} container style={{ marginTop: 5 }}>
                      {step4.developer_type.value === "hourly" ? (
                        <Grid item xs={12}>
                          <CustomTextField
                            placeholder={"Enter hours (minimum 4)"}
                            value={hourlyValue}
                            onChange={(e) => {
                              const val = e.target.value;
                              setHourlyValue(val);
                              // Update project_duration when hourly value changes
                              onChangeStep4(
                                { target: { value: `${val} Hours` } },
                                "project_duration"
                              );
                              if (val > 4) {
                                setHourlyError(false);
                              }
                            }}
                            error={hourlyError}
                            helperText={hourlyError ? "Please enter at least 5 hours" : ""}
                            startAdornment={
                              <InputAdornment position="start">
                                <img src={CLOCK_RIGHT} alt={"CLOCK_RIGHT"} />
                              </InputAdornment>
                            }
                            otherInputProps={{
                              sx: {
                                '&.MuiOutlinedInput-root': {
                                  backgroundColor: "white",
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#5E17EB',
                                  borderWidth: '1px',
                                },
                              },
                            }}
                          />
                        </Grid>
                      ) : (
                        <Select
                          value={step4.project_duration.value}
                          placeholder={"Select duration"}
                          onChange={(e) => onChangeStep4(e, "project_duration")}
                          error={step4.project_duration.showError}
                          startAdornment={
                            <InputAdornment position="start">
                              <img src={CLOCK_RIGHT} alt={"CLOCK_RIGHT"} />
                            </InputAdornment>
                          }
                          sx={{
                            width: '100%',
                            height: '56px',
                            background: 'white',
                            borderRadius: '10px',
                            '& .MuiOutlinedInput-notchedOutline': {
                              border: '1px solid #DDDDDD'
                            }
                          }}
                        >
                          {[
                            "1 Month",
                            "2 Months", 
                            "3 Months",
                            "4 Months",
                            "5 Months", 
                            "6 Months",
                            "7 Months",
                            "8 Months",
                            "9 Months",
                            "10 Months",
                            "11 Months",
                            "12 Months"
                          ].map((duration) => (
                            <MenuItem key={duration} value={duration}>
                              <CustomLabelSmallRegular text={duration} />
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    </Grid>
                  </Grid>
                
                  <Grid item xs={12} container justifyContent={"flex-start"} style={{ marginTop: "20px" }}>
                    <Grid item style={{ marginLeft: 10 }}>
                        <CustomLabelXSmallRegular text={"Your Total Cost"} />
                    </Grid>
                        {/* All items in single column */}
                        <Grid container direction="column" spacing={2} sx={{ width: '100%' }}>
                        {/* Total Cost Summary Row */}
                        <Grid item>
                            <Paper
                            elevation={0}
                            sx={{
                                width: "100%",
                                padding: "24px",
                                borderRadius: "16px"
                            }}
                            >
                            <Grid container justifyContent="space-between" alignItems="center">
                                <Grid item>
                                <Box 
                                    component={'img'} 
                                    alt={'logo-circle'} 
                                    src={OSTRYX_LOGO}
                                    sx={{
                                        width: {xs: "80px"}, 
                                        height: {xs: "80px"},
                                        zIndex: 2
                                    }}
                                />
                                </Grid>
                                <Grid item>
                                {(() => {
                                    const { totalCost, savings, isHourly, totalHours } = calculateTotalCost(
                                    selectedTags,
                                    step3.developer_level.value,
                                    step4.project_duration.value,
                                    step4.developer_type.value,
                                    hourlyValue
                                    );
                                    return (
                                    <Grid container direction="column" alignItems="flex-end">
                                        {!isHourly && <Grid item container alignItems="center" 
                                                style={{
                                                    border: "1px solid #5E17EB",
                                                    borderRadius: 50,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    gap: 1,
                                                    padding: "10px",
                                                    backgroundColor: "#FBF6FF",
                                                    display: "flex",
                                                    textAlign: "center"
                                                }}
                                            > 
                                            <Grid item style={{ display: "flex", alignItems: "center" }}>
                                                <StarIcon />
                                            </Grid>
                                             <Grid item style={{ marginLeft: "8px", color: "#5E17EB", alignItems: "center" }}>
                                                <CustomLabelXSmallRegular 
                                                text={`Saved $${savings.toLocaleString()}`}
                                                color={"#5E17EB"}
                                                sx={{
                                                    textAlign: "center"
                                                }}
                                                />
                                            </Grid>
                                        </Grid>}
                                        <CustomLabelXSmallRegular 
                                                text={isHourly ? `${totalHours} Hours` : `1 Month`}
                                                style={{
                                                    marginTop: "10px",
                                                    textAlign: "center"
                                                }}
                                        />
                                        {!isHourly && <Grid style={{ textDecoration: "line-through" }}>
                                            <CustomLabelXSmallRegular 
                                                text={`$${(totalCost).toLocaleString()}`}
                                                style={{
                                                    marginTop: "10px",
                                                    textAlign: "center",
                                                    color: "#666666"
                                                }}
                                            />
                                        </Grid>}
                                        {!isHourly && <CustomLabelMediumSmallBold 
                                        text={`$${(totalCost - savings).toLocaleString()}`}
                                        color={"#5E17EB"}
                                       
                                        sx={{
                                            fontSize: "32px",
                                        }}
                                        />}
                                        {isHourly && <CustomLabelMediumSmallBold 
                                        text={`$${(totalCost).toLocaleString()}`}
                                        color={"#5E17EB"}
                                        
                                        sx={{
                                            fontSize: "32px",
                                        }}
                                        />}
                                        
                                    </Grid>
                                    );
                                })()}
                                </Grid>
                            </Grid>

                             {/* Stack Rows */}
                        {Object.entries(selectedTags).map(([category, tag]) => (
                            <Grid item key={category}>
                            <Paper
                                elevation={0}
                                sx={{
                                marginTop: "10px",
                                width: "100%",
                                }}
                            >
                                <Grid container justifyContent="space-between" alignItems="center">
                                    {/* Left side: Icon and Stack Details */}
                                    <Grid item container xs={9}>
                                        {/* Icon and Text Container */}
                                        <Grid container alignItems="center" spacing={2}>
                                            {/* Icon */}
                                            <Grid item>
                                                <Box
                                                    sx={{
                                                        width: 32,
                                                        height: 32,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <img 
                                                        src={techStackIcons[tag] || CODE} 
                                                        alt={tag}
                                                        style={{ 
                                                            width: 24, 
                                                            height: 24,
                                                            filter: 'brightness(0) saturate(100%) invert(67%) sepia(95%) saturate(1595%) hue-rotate(166deg) brightness(99%) contrast(97%)'
                                                        }} 
                                                    />
                                                </Box>
                                            </Grid>

                                            {/* Text Content */}
                                            <Grid item>
                                                <Grid container direction="column" spacing={0.5}>
                                                    <Grid item>
                                                        <CustomLabelSmallRegular 
                                                            text={tag}
                                                            textAlign={"left"}
                                                            sx={{
                                                                fontSize: "12px",
                                                                color: "#111111",
                                                                textAlign: "left"
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <CustomLabelSmallRegular 
                                                            text={category}
                                                            textAlign={"left"}
                                                            fontWeight={700}
                                                            sx={{
                                                                fontWeight: 700,
                                                                color: "#666666",
                                                                textAlign: "left"
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <CustomLabelXSmallRegular 
                                                            text={`${step3.developer_level.value} — ${step4.developer_type.value}`}
                                                            textAlign={"left"}
                                                            sx={{
                                                                fontSize: "12px",
                                                                color: "#666666",
                                                                textAlign: "left"
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    {/* Price */}
                                    <Grid item>
                                        <CustomLabelXSmallRegular 
                                        text={`$${techStackPricing[category][step3.developer_level.value]}/hr`}
                                        sx={{
                                            fontSize: "20px",
                                            color: "#5E17EB"
                                        }}
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                            </Grid>
                            ))}
                            </Paper>
                        </Grid>
                        </Grid>
                    </Grid>
                  <Grid
                    item
                    container
                    justifyContent={"center"}
                    sx={{ paddingBottom: "40px", marginTop: "20px" }}
                  >
                    <div>
                      <Grid
                        container
                        alignItems={"center"}
                        justifyContent={"center"}
                        sx={{
                          border: "1.5px solid #DDDDDD",
                          borderRadius: "20px",
                          padding: { xs: "10px 15px", md: "12px 80px" },
                          background: "white",
                          marginTop: "20px",
                          gap: "5px",
                          cursor: "pointer",
                        }}
                        onClick={(e) => setProgress(45)}
                      >
                        <Grid item style={{ marginTop: "2px" }}>
                          <img src={ARROR_LEFT} alt={"ARROR LEFT"} />
                        </Grid>

                        <Grid item>
                          <CustomLabelSmallMedium
                            text={"Back"}
                            color={"black"}
                          />
                        </Grid>
                      </Grid>
                    </div>

                    <div style={{ marginLeft: "20px" }}>
                      <Grid
                        container
                        alignItems={"center"}
                        justifyContent={"center"}
                        sx={{
                          border: "1.5px solid #F5F5F5",
                          borderRadius: "20px",
                          padding: { xs: "10px 40px", md: "12px 80px" },
                          background: "#5E17EB",
                          marginTop: "20px",
                          gap: "5px",
                          cursor: "pointer",
                        }}
                        onClick={onSubmitStep4}
                      >
                        <Grid item>
                          <CustomLabelSmallMedium
                            text={"Next"}
                            color={"white"}
                          />
                        </Grid>

                        <Grid item style={{ marginTop: "4px" }}>
                          <img src={ARROW_RIGHT_WITHOUT_BORDER} alt={"ARROW_RIGHT_WITHOUT_BORDER"} />
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            )}
            {progress === 90 &&
            <Grid container>
                <Grid container sx={{marginTop: {xs: "30px", md: "40px"}}}>
                    <Grid item xs={12} container justifyContent={"flex-start"}>
                        <Grid item style={{marginLeft: 10}}>
                            <CustomLabelXSmallRegular text={"Job Description"}/>
                        </Grid>
                        <Grid item container style={{marginTop: 5}}>
                            <CustomTextMultipleField placeholder={"Tell us about your job..."}
                                                        rows={5}
                                                        value={step5.job_description.value}
                                                        onChange={(e) => onChangeStep5(e, 'job_description')}
                                                        error={step5.job_description.showError}
                                                        helperText={step5.job_description.showError ? step5.job_description.error : ""}
                                                        otherInputProps={{
                                                            sx: {
                                                                '&.MuiOutlinedInput-root': {
                                                                    backgroundColor: "white",
                                                                },
                                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                borderColor: '#5E17EB',
                                                                borderWidth: '1px',
                                                            },
                                                            },
                                                        }}
                                                        

                            />
                        </Grid>
                    </Grid>


                    <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "15px"}}>
                        <Grid item style={{marginLeft: 10}}>
                            <CustomLabelXSmallRegular text={"Additional Information"}/>
                        </Grid>
                        <Grid item container style={{marginTop: 5}}>
                            <CustomTextMultipleField
                                placeholder={"Write something here..."}
                                rows={5}
                                value={step5.addiotional_info.value}
                                onChange={(e) => onChangeStep5(e, 'addiotional_info')}
                                error={step5.addiotional_info.showError}
                                helperText={step5.addiotional_info.showError ? step5.addiotional_info.error : ""}
                                otherInputProps={{    
                                sx: {
                                    '&.MuiOutlinedInput-root': {
                                        backgroundColor: "white",
                                        },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#5E17EB',
                                    borderWidth: '1px',
                                    },
                                },
                                }}

                            />
                        </Grid>
                    </Grid>


                    <Grid item container justifyContent={"center"}
                            sx={{paddingBottom: "40px", marginTop: "20px"}}>
                        <div>
                            <Grid container alignItems={"center"} justifyContent={"center"}
                                    sx={{
                                        border: "1.5px solid #DDDDDD",
                                        borderRadius: "20px",
                                        padding: {xs: "10px 15px", md: "12px 80px"},
                                        background: "white", marginTop: "20px",
                                        gap: "5px",
                                        cursor: "pointer"

                                    }}
                                    onClick={(e) => setProgress(65)}
                            >
                                <Grid item style={{marginTop: "2px"}}>
                                    <img src={ARROR_LEFT} alt={"ARROW LEFT"} />
                                </Grid>

                                <Grid item>
                                    <CustomLabelSmallMedium text={"Back"} color={"black"}/>
                                </Grid>

                            </Grid>
                        </div>

                        <div style={{marginLeft: "20px"}}>
                            <Grid container alignItems={"center"} justifyContent={"center"}
                                    sx={{
                                        border: "1.5px solid #F5F5F5",
                                        borderRadius: "20px",
                                        padding: {xs: "10px 15px", md: "15px 80px"},
                                        background: "#5E17EB", marginTop: "20px",
                                        gap: "10px",
                                        cursor: "pointer"

                                    }}
                                    onClick={(e) => {
                                        //setShowOnDemandDevelopers(false)
                                        //setShowConfirmation(true)
                                        onSubmitStep5(e)
                                    }}
                            >
                                <Grid item>
                                    <CustomLabelSmallMedium text={"Submit"} color={"white"}/>
                                </Grid>


                                <Grid item>
                                    <img src={TICK} alt={"TICK"} />
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
            }
          </Grid>
        </form>
      </Grid>
      </Grid>
      </Grid>
    </>
  );
};

export default OnDemandDevelopers;
